// Importing React to build the component.
import React from 'react';

// Importing the Boostrap Col, Container, and Row components.
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

// Importing the CSS file for styling the profile page.
import '../ProfilePage.css';

// Importing Navbar, ProfilePageHeader, ProfileCard, CurrentCoursesCard, and
// PreviousCoursesCard components.
import ProfilePageHeader from './ProfilePageHeader';
import ProfileCard from './ProfileCard';
import UpdateYearAndMajorCard from './UpdateYearAndMajorCard';
import NavBar from './Navbar'

// ProfilePage component: Combines Navbar, ProfilePageHeader, ProfileCard,
// CurrentCoursesCard, and PreviousCoursesCard components to create the profile
// page.
function ProfilePage() {
    return  <div>
                {/* Render the Navbar component. */}
                <NavBar />
                <div className="app-page-shell">
                {/* Render the ProfilePageHeader component. */}
                <ProfilePageHeader />
                <Container className="profile-page-content">
                    <Row>
                        <Col xs={12} md={4}>
                            {/* Render the ProfileCard component. */}
                            <ProfileCard />
                        </Col>
                        <Col xs={12} md={4}>
                            {/* Render the UpdateYearAndMajorCard component. */}
                            <UpdateYearAndMajorCard />
                        </Col>
                    </Row>
                </Container>
                </div>
            </div>
}

// Exporting the ProfilePage component so it can be imported and used in other
// parts of the app.
export default ProfilePage;
